import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const KNOWN_FEATURES: Record<string, string> = {
  'analyze:showDefaultOrgMenuItem': 'Allow to change default organization',
  'analyze:aspice-widgets': 'Automotive SPICE Widgets',
  'analyze:chatbot': 'AI Chat Bot',
  'analyze:custom-metrics': 'Custom Metrics',
  'analyze:global-filter': 'Global Filters',
  'analyze:import-snapshot': 'Import Snapshot button',
  'analyze:secure-widgets': 'SECURE Dashboard Widgets',
}

const STORAGE_KEY = 'analyze:featureFlagOverrides'

export const useFeatureFlagStore = defineStore('featureFlagStore', () => {
  const stored = localStorage.getItem(STORAGE_KEY)
  const overrides = ref<Record<string, boolean>>(stored ? JSON.parse(stored) : {})

  const getOverride = computed(() => (fqn: string): boolean | null => {
    return fqn in overrides.value ? overrides.value[fqn] : null
  })

  function setOverride(fqn: string, value: boolean | null) {
    if (value === null) {
      delete overrides.value[fqn]
    } else {
      overrides.value[fqn] = value
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides.value))
  }

  function resetAll() {
    overrides.value = {}
    localStorage.removeItem(STORAGE_KEY)
  }

  return { overrides, getOverride, setOverride, resetAll }
})
